import { lazy } from 'react'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'

import { RouteObject } from 'react-router-dom'

const List = lazy(() => import('./components/List'))
const Create = lazy(() => import('./components/Create'))

const KPIModule: RouteObject = {
    path: 'kpi-manage',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: 'create',
            element: <Create />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default KPIModule
